import React, { useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { OverviewView } from "./components/OverviewView";
import { ClubDetailView } from "./pages/club/ClubDetailView";
import { TGDetailView } from "./pages/training-group/TGDetailView";
import { SportAssociationMap } from "./types/SportAssociation";

export interface AppProps {
  backendUrl: string;
  runInitialSearch: boolean;
  sportAssociation: string;
}

interface AppTypeProps {
  type: "TrainingGroup" | "Club";
}

export const App: React.FC<AppProps & AppTypeProps> = (
  props: AppProps & AppTypeProps,
) => {
  const [firstEnter, setFirstEnter] = useState(true);
  const { runInitialSearch, ...others } = props;

  if (!SportAssociationMap.has(props.sportAssociation)) {
    return (
      <div>
        Es muss eine supportete Sportvereinigung angegeben werden um die Seite
        verwenden zu können.
      </div>
    );
  }

  return (
    <React.StrictMode>
      <HashRouter>
        <Routes>
          <Route
            path={props.type === "Club" ? "/training-group/:id" : "/:id"}
            element={
              <TGDetailView
                backendUrl={props.backendUrl}
                sportAssociation={props.sportAssociation}
              />
            }
          />
          {props.type === "Club" && (
            <Route
              path="/club/:id"
              element={
                <ClubDetailView
                  backendUrl={props.backendUrl}
                  sportAssociation={props.sportAssociation}
                />
              }
            />
          )}
          <Route
            path="/"
            element={
              <OverviewView
                {...others}
                sportAssociation={props.sportAssociation}
                runInitialSearch={runInitialSearch || !firstEnter}
                setFirstEnter={setFirstEnter}
              />
            }
          />
        </Routes>
      </HashRouter>
    </React.StrictMode>
  );
};
